<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <!--판매현황 -->
            <piaf-breadcrumb :heading="$t('menu.sales-amount')" />
            <div class="separator mb-5"></div>
        </b-colxx>
    </b-row>
    <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-4">
                <b-row>
                    <b-colxx xxs="12" md="12" lg="12" xl="12">
                        <div class="form-group has-float-label reoportDiv">
                            <b-input-group>
                                <template v-slot:prepend>
                                    <b-input-group-text>
                                        <b-icon icon="calendar"></b-icon>
                                    </b-input-group-text>
                                </template>
                                <v-date-picker mode="single" v-model="startDate" :input-props="{ class:'form-control', placeholder: ''  }"></v-date-picker>
                                <!--   :max-date="endDate" -->
                            </b-input-group>
                            <span>시작날짜</span>
                        </div>
                        <!-- </b-colxx>
            <b-colxx xxs="12" md="6" lg="3" xl="3"> -->
                        <div class="form-group has-float-label reoportDiv">
                            <b-input-group>
                                <template v-slot:prepend>
                                    <b-input-group-text>
                                        <b-icon icon="calendar"></b-icon>
                                    </b-input-group-text>
                                </template>
                                <v-date-picker mode="single" v-model="endDate" :input-props="{ class:'form-control', placeholder: ''  }"></v-date-picker>
                                <!--  :min-date="startDate" -->
                            </b-input-group>
                            <span>종료날짜</span>
                        </div>
                        <div class="reoportDiv mb-3 ml-1">
                            <b-input-group>

                                <v-select v-if="this.userRole== 'BRAND'" :options="storeOptions" v-model="selectedStore" :reduce="item=>item.value" label="label" style="width:200px;" />
                                <b-button class="ml-1" variant="primary default" @click="searchData">검색</b-button>
                            </b-input-group>
                        </div>
                    </b-colxx>
                </b-row>

                <b-row>
                    <b-colxx xxs="12">
                        <b-card class="mb-4" title="판매내역">
                            <template v-if="isLoad">
                                <b-row>
                                    <b-table head-variant="light" ref="general-table" class="vuetable" id="table-transition-example" :items="salesList" :fields="fields" primary-key="bookingId" responsive v-model="visibleRows" sticky-header="500px" show-empty>
                                        <template v-slot:empty>
                                            <h3 style="text-align:center">검색된 판매 데이터가 없습니다.</h3>
                                        </template>

                                        <template v-slot:cell(date)="row">
                                            <span>
                                                {{ row.item.salesDate }}
                                            </span>
                                        </template>
                                        
                                        <template v-slot:cell(Default)="row">
                                            <span v-if="row.item.Default == null || row.item.Default.salesAmountTotal >=0" class="cls_click_black" @click="getDetail(row.item.salesDate,'Default', row.item)">
                                                {{ row.item.Default != null ? row.item.Default.salesAmountTotal : '' | currency }}
                                            </span>
                                            <span v-else class="cls_click" @click="getDetail(row.item.salesDate,'Default', row.item)">
                                                {{ row.item.Default != null ? row.item.Default.salesAmountTotal : '' | currency }}
                                            </span>
                                        </template>

                                        <template v-slot:cell(SelfSales)="row">
                                            <span v-if="row.item.SelfSales == null || row.item.SelfSales.salesAmountTotal >=0" class="cls_click_black" @click="getDetail(row.item.salesDate,'SelfSales', row.item)">
                                                {{ row.item.SelfSales != null ? row.item.SelfSales.salesAmountTotal : '' | currency }}
                                            </span>
                                            <span v-else class="cls_click" @click="getDetail(row.item.salesDate,'SelfSales', row.item)">
                                                {{ row.item.SelfSales != null ? row.item.SelfSales.salesAmountTotal : '' | currency }}
                                            </span>
                                        </template>

                                        <template v-slot:cell(Summary)="row">
                                            <span  v-if="row.item.Summary == null || row.item.Summary >=0" class="cls_click_black" @click="getDetail(row.item.salesDate,'Summary', row.item)">
                                                {{ row.item.Summary|currency }}
                                            </span>
                                            <span  v-else class="cls_click" @click="getDetail(row.item.salesDate,'Summary', row.item)">
                                                {{ row.item.Summary|currency }}
                                            </span>
                                        </template>
                                    
                                        <template v-slot:custom-foot>
                                            <b-tr>
                                                <b-th style="text-align:center;background:#f6c797 !important">합계 :</b-th>
                                                <b-th style="text-align:center;background:#f6c797 !important">
                                                    <span v-if="DefaultTotal ==null || DefaultTotal >=0" class="cls_click_black" @click="getDetail(null,'Default' , salesList)">
                                                        {{ DefaultTotal | currency }}
                                                    </span>
                                                    <span v-else class="cls_click" @click="getDetail(null,'Default' , salesList)">
                                                        {{ DefaultTotal | currency }}
                                                    </span>
                                                </b-th>
                                                <b-th style="text-align:center;background:#f6c797 !important">
                                                    <span v-if="SelfSalesTotal ==null || SelfSalesTotal >=0" class="cls_click_black" @click="getDetail(null,'SelfSales' , salesList)">
                                                        {{ SelfSalesTotal | currency }}
                                                    </span>
                                                    <span v-else class="cls_click" @click="getDetail(null,'SelfSales' , salesList)">
                                                        {{ SelfSalesTotal | currency }}
                                                    </span>
                                                </b-th>
                                                <b-th style="text-align:center;background:#f6c797 !important">
                                                    <span v-if="SummaryTotal ==null || SummaryTotal >=0" class="cls_click_black" @click="getDetail(null,'Summary' , salesList)">
                                                        {{ SummaryTotal | currency }}
                                                    </span>
                                                    <span v-else class="cls_click" @click="getDetail(null,'Summary' , salesList)">
                                                        {{ SummaryTotal | currency }}
                                                    </span>
                                                </b-th>
                                            </b-tr>
                                        </template>

                                    </b-table>
                                </b-row>
                            </template>
                            <template v-else>
                                <div class="loading"></div>
                            </template>
                        </b-card>
                    </b-colxx>
                </b-row>

                <b-row v-show="selectFlag">
                    <b-colxx xxs="12">
                        <b-card class="mb-4" title="세부내역">
                            <b-tabs content-class="m-4" active-nav-item-class="font-weight-bold text-danger">
                                <b-tab title="쿠폰별로 보기">
                                    <coupon-list-view :data="salesList" ref="coupon_list" />
                                </b-tab>
                                <b-tab title="주문별로 보기">
                                    <order-list-view :data="salesList" :useDate="false" ref="order_list" :fullPath="$route.fullPath" />
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </b-colxx>
                </b-row>
            </b-card>
        </b-colxx>
    </b-row>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import api from "../../constants/api";
import {
    alignTableCenter,
    currencyFilter
} from "../../utils";
import '../../assets/css/custom/common.css'
import SalesCouponList from './components/SalesCouponList'
import SalesOrderList from './components/SalesOrderList';

const now = new Date()
export default {
    components: {
        'v-select': vSelect,
        'coupon-list-view': SalesCouponList,
        'order-list-view': SalesOrderList,
    },
    filters: {
        ...currencyFilter
    },
    data() {
        return {
            userRole: null,
            isLoad: false,
            startDate: this.$moment(new Date(now.getFullYear(), now.getMonth(), 1)).toDate(),
            endDate: this.$moment(now).toDate(),
            searchMaxDate: this.$moment(new Date(now.getFullYear(), now.getMonth() + 1, 0)).toDate(),
            selectedStore: null,
            storeOptions: [{
                label: '전체매장',
                value: null
            }],
            selectFlag: false,
            salesList: [],
            visibleRows: [],
            fields: [{
                    key: "date",
                    label: "날짜",
                    ...alignTableCenter
                },
                {
                    key: "Default",
                    label: "외부판매",
                    ...alignTableCenter
                },
                {
                    key: "SelfSales",
                    label: "자체판매",
                    ...alignTableCenter
                },
                {
                    key: "Summary",
                    label: "합계",
                    ...alignTableCenter
                },
            ],
            selectedDate: null,
            selectedGoodsType: null,
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName']),

        DefaultTotal() {
            return this.visibleRows.reduce((accum, item) => {
                return accum + (item.Default != null ? Number(item.Default.salesAmountTotal) : 0)
            }, 0.0)
        },
        SelfSalesTotal() {
            return this.visibleRows.reduce((accum, item) => {
                return accum + (item.SelfSales != null ? Number(item.SelfSales.salesAmountTotal) : 0)
            }, 0.0)
        },
        SummaryTotal() {
            return this.visibleRows.reduce((accum, item) => {
                return accum + item.Summary
            }, 0.0)
        },

    },

    mounted() {
        this.userRole = this.currentUser.userRole.split('_')[0]
        this.getStore()
        this.searchData();
        console.log(this.$route.fullPath)
    },

    methods: {

        async getStore() {
            const vm = this
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.brandStoreCodeSearch)

            await this.$http.get(reqURL, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    res.data.data.forEach(function (value, index) {
                        vm.storeOptions.push({
                            label: value.storeName,
                            value: value.storeCode
                        })
                    })
                } else {
                    throw 400
                }

            }).catch(err => {

            })

        },

        async searchData() {
            if (this.startDate > this.endDate) {
                alert('조회 시작일은 조회 종료일 이전이어야 합니다.');
                return false;
            }
            this.selectFlag = false

            this.salesList = []
            const vm = this
            this.isLoad = false

            if (this.startDate == null) {
                alert("시작일을 설정해주세요")
                return
            }
            if (this.endDate == null) {
                alert("종료일을 설정해주세요")
                return
            }

            const params = {
                salesFrom: this.$moment(this.startDate).format('YYYY-MM-DD'),
                salesTo: this.$moment(this.endDate).format('YYYY-MM-DD'),
                storeCode: this.selectedStore
            }

            // console.log("params", params);

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.sales.saleaAmounts)
                Object.assign(params, {
                    storeCode: this.selectedStore
                })
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.sales.saleaAmountsStr)
            }

            await this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    // console.log("result", res.data.data);

                    const dates = res.data.data.dates

                    dates.forEach((v) => {
                        var sales = {
                            salesDate: v.salesDate,
                            Default: null,
                            SelfSales: null,
                            Summary: 0
                        };

                        v.goodsTypes.forEach(function (value, index) {

                            if (value.selfSales == true) {
                                sales.SelfSales = value
                                sales.Summary += Number(value.salesAmountTotal)
                            }

                            if (value.selfSales == false) {
                                sales.Default = value
                                sales.Summary += Number(value.salesAmountTotal)
                            }

                        })
                        vm.salesList.push(sales)
                    })

                    // console.log(vm.salesList);
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })

            // console.log(this.salesList);
            this.isLoad = true
        },
        getDetail(date, goods_type, item) {
            console.log(date, goods_type, item)
            this.selectFlag = false

            this.$refs.coupon_list.init(date, goods_type, item)
            this.$refs.order_list.init(date, goods_type, item)
            this.selectFlag = true
        }
    },
    watch: {}
}
</script>
